export const ALL_REPORT_STATUSES_VALUE = null;

export const REPORT_STATUS_OPTIONS = [
    {
        value: ALL_REPORT_STATUSES_VALUE,
        label: "All statuses",
    },
    {
        value: 0,
        label: "To Do",
    },
    {
        value: 1,
        label: "In Progress",
    },
    {
        value: 2,
        label: "Complete",
    },
];

export const REPORT_STATUS_LABELS = {
    0: "To Do",
    1: "In Progress",
    2: "Complete",
};

export const getReportStatusLabel = (status) => {
    if (typeof status === "number") {
        return REPORT_STATUS_LABELS[status] || `${status}`;
    }

    if (typeof status === "string" && status.trim()) {
        return status;
    }

    return "Unknown";
};

export const getNormalizedReportStatus = (status) =>
    typeof status === "string" ? status.trim().toLowerCase() : status;

export const getReportStatusBadgeClass = (status) => {
    const label = getReportStatusLabel(status);

    if (label === "To Do") {
        return "bg-red-500";
    }

    if (label === "In Progress") {
        return "bg-yellow-500";
    }

    return "bg-gray-500";
};
